module.exports = __webpack_public_path__ + "img/logo68.ab981893.png";